import React from 'react'
import Payment from './Payment'
import Shipping from './Shipping'
import { Col, Row } from 'react-bootstrap'

const ShipingPayment = () => {
  return (
    <div className='w-100'>
      <Row className='g-2'>
        <Col sm={12} md={6} lg={8}>
          <Shipping />
        </Col>
        <Col sm={12} md={6} lg={4}>
          <Payment />
        </Col>
      </Row>
    </div>
  )
}

export default ShipingPayment